<template>
  <b-modal
    id="changePasswordModal"
    header-border-variant="dark"
    title="Изменение пароля"
    size="md"
    modal-class="main-modal page-main-block"
    header-class="text-white border-0 pb-0"
    title-class="text-center underlined-muted-title"
    footer-class="border-0"
    hide-footer
    body-class="pb-2 pt-1 px-3"
    centered
  >
    <div v-if="userData" class="recover-account-area col-12 px-0 py-2">
      <div class="col-12 mt-2 px-0 mx-auto">
        <b-row class="w-100 mt-2 mx-auto">
          <b-form class="col-12 mb-4 mx-auto recover-form px-0" @submit.prevent="changePassword"
          >
            <div class="col-12 px-0">
              <b-form-group>
                <div class="col-12">
                  <label class="col-form-label white-color">Пароль</label>
                </div>
                <div class="col-12">
                  <input
                      v-model="payload.password"
                      type="text"
                      class="form-control main-modal-input"
                      required
                  >
                </div>
              </b-form-group>

              <b-form-group>
                <div class="col-12">
                  <label class="col-form-label white-color">Новый пароль</label>
                </div>
                <div class="col-12">
                  <input
                      v-model="payload.new_password"
                      required
                      type="password"
                      class="form-control main-modal-input"
                  >
                </div>
              </b-form-group>

              <b-form-group>
                <div class="col-12">
                  <label class="col-form-label white-color">Пароль еще раз</label>
                </div>
                <div class="col-12">
                  <input
                      v-model="payload.new_password_confirm"
                      type="password"
                      required
                      class="form-control main-modal-input"
                  >
                </div>
              </b-form-group>
            </div>
            <b-form-group>
              <div class="col-12">
                <label class="col-form-label white-color"> Введите символы которые видите на картинке</label>
              </div>
              <div class="col-12 row mx-0 justify-content-between">
                <div class="col-6 col-sm-4 px-0">
                  <captcha ref="pass_change_captcha" class="ml-0" :captcha_key="'pass_change_captcha'"/>
                </div>
                <div class="col-6 col-sm-8 px-0">
                  <input
                      v-model="payload.captcha"
                      required
                      class="form-control main-modal-input"
                  >
                </div>
              </div>
            </b-form-group>

            <b-row class="w-100 mt-3 mx-auto col-12">
              <alert :message="response" />
            </b-row>

            <b-row class="col-12 mx-0">
              <div class="mx-auto">
                <button
                    name="submit"
                    class="btn red-btn text-white px-4"
                    :disabled="isSubmitting"
                >
                  Подтвердить
                </button>
              </div>
            </b-row>
          </b-form>
        </b-row>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Alert from "@/components/Alert";
import Captcha from "@/components/main/Captcha";
export default {
  name: 'ChangePassword',
  components: {Captcha, Alert},
  computed: {
    userData () {
      return this.$store.getters.userData
    },
    isMobile () {
      return this.$_config.environment.mobile
    }
  },
  data () {
    return {
      isSubmitting: false,
      response: null,
      payload: {
        captcha: '',
        password: '',
        new_password: '',
        new_password_confirm: ''
      }
    }
  },
  methods: {
    changePassword () {
      this.response = { status: 'loading' }
      this.isSubmitting = true
      let formData = new FormData();
      formData.append('password', this.payload.password);
      formData.append('new_password', this.payload.new_password);
      formData.append('new_password_confirm', this.payload.new_password_confirm);
      formData.append('pass_change_captcha', this.payload.captcha);

      this.axios.post(
          this.$_config.baseUrl + '/Api/changePassword',
          formData,
      ).then(({ data }) => {
        this.isSubmitting = false
        this.response = data
        if (data.status === 'ok') {
          this.payload.captcha = ''
          setTimeout(() => {
            this.$root.$emit('bv::hide::modal', 'changePasswordModal')
            this.response = null
            this.payload.password = ''
            this.payload.new_password = ''
            this.payload.new_password_confirm = ''
          }, 3000)
        }
        this.$refs.pass_change_captcha.updateCaptcha()
      }).catch((err) => {
        if (err) {
          this.isSubmitting = false
          this.response = { status: 'error', msg: err.response.data.errors }
        }
      })
    },
  }
}
</script>

<style>
    #changePasswordModal .modal-dialog{
        background-color: transparent;
    }
    #changePasswordModal .modal-header .close {
        margin: 0 !important;
    }
    #changePasswordModal .modal-body {
        padding-left: 0;
        padding-right: 0;
    }
</style>
